// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2pUcg","rootCenter":"LoadMoreObserver_rootCenter__iNTOi","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1ziIb"};